<template>
  <div class="side-category">
    <router-link :to="categoriaLink" v-slot="{ href, navigate }">
      <button class="side-category-title" :href="href" @click="navigate()">
        {{ item }}
      </button>
    </router-link>

    <ul v-if="filhas && filhas.length" class="side-sublist">
      <li v-for="(f, idx) in filhas" :key="idx" class="side-subitem">
        <router-link
          :to="categoriaLinkFilha + f.codigo"
          v-slot="{ href, navigate }"
        >
          <button class="side-subitem-btn" :href="href" @click="navigate()">
            {{ f.nome }}
          </button>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ItemCategoriaSide",
  props: ["item", "codigo", "filhas", "textColor"],
  computed: {
    loja() {
      return this.$store.getters["loja/lojaSelecionada"];
    },
    tipo() {
      return this.$store.getters["loja/tipoSelecionado"];
    },
    categoriaLink() {
      return (
        "/" +
        this.tipo +
        "/" +
        this.loja +
        "/produtos/" +
        "categorias/" +
        this.codigo
      );
    },
    categoriaLinkFilha() {
      return "/" + this.tipo + "/" + this.loja + "/produtos/" + "categorias/";
    },
  },
};
</script>

<style scoped>
.side-category {
  margin-bottom: 8px;
}
.side-category-title {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 10px 12px;
  font-weight: 700;
  color: #13433a;
  cursor: pointer;
}
.side-sublist {
  list-style: none;
  margin: 0;
  padding: 4px 0 8px 8px;
}
.side-subitem {
  margin: 0;
}
.side-subitem-btn {
  background: transparent;
  border: none;
  text-align: left;
  padding: 6px 8px;
  width: 100%;
  color: #333;
  cursor: pointer;
}
.side-category-title:hover,
.side-subitem-btn:hover {
  background: #f6f6f6;
}
</style>
